import React from 'react'
import "./index.scss"

interface AuthPageFooterProps {
    type: "signin" | "signup"
}

const AuthPageFooter = ({ type }: AuthPageFooterProps) => {

const text = type === "signin" ? "By signing in, you agree to our" : "By signing up, you agree to our"
  return (
    <div className='auth-page-footer'>
        <p>{text} <a href="https://www.qualifyme.ai/terms">{type === "signin" ? "Terms of Service" : "Terms of Service"} </a> and <a href="https://www.qualifyme.ai/privacy">{type === "signin" ? "Privacy Policy" : "Privacy Policy"}</a></p>
    </div>
  )
}

export default AuthPageFooter